import React from 'react'
import { serverForImages } from '../../config'

interface IVideoItemProps {
  url: string
  title: string
}

const VideoItem: React.FC<IVideoItemProps> = ({ url }) => {
  return (
    <video controls className='h-full w-max m-auto inset-0 object-scale-down'>
      <source src={`${serverForImages}${url}`} type='video/mp4' />
    </video>
  )
}

export default VideoItem
